import { render, staticRenderFns } from "./SubGroupEditForm.vue?vue&type=template&id=0a660798&scoped=true&"
import script from "./SubGroupEditForm.vue?vue&type=script&lang=js&"
export * from "./SubGroupEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a660798",
  null
  
)

export default component.exports